import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { Accordion, AccordionContext, Card, useAccordionToggle } from 'react-bootstrap';
import styles from './Faq.module.scss';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../FullscreenLoader/FullscreenLoader';

const FaqComponent = () => {
  const { staticData } = useFirebase();

  if (!staticData || !Object.keys(staticData).length) return <FullscreenLoader fullscreen={false} />;

  return (
    <div className={'my-5'}>
      <Accordion>
        {(staticData.faqs || []).map((faq) => {
          return (
            <Card key={faq.id} className={styles.faqCard}>
              <ContextAwareToggle eventKey={faq.id}>{faq.question}</ContextAwareToggle>
                <Accordion.Collapse eventKey={faq.id}>
                  <Card.Body id={`faq-panel-${faq.id}`} className={`${styles.faqBody} pb-1`} data-testid="faq-body">
                  {faq.answer.map((segment, i) => (
                    <p key={i.toString()} className={'text-left'}>{segment}</p>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    </div>
  );
};

const ContextAwareToggle = ({ children, eventKey, callback = null }) => {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));
  const isCurrentEventKey = currentEventKey === eventKey;

  return (
      <Card.Header
        className={styles.faqHeader}
        data-testid="faq-header"
        onClick={decoratedOnClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            decoratedOnClick(event);
          }
        }}
        role="button"
        tabIndex={0}
        aria-expanded={isCurrentEventKey}
        aria-controls={`faq-panel-${eventKey}`}
      >
      <div className="d-flex justify-content-between align-items-center">
        {children}
        <FontAwesomeIcon icon={isCurrentEventKey ? faChevronUp : faChevronDown} />
      </div>
    </Card.Header>
  );
};

export { FaqComponent as Faq };
